import React from "react";
import "../footer/footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-bottom">
        <div className="d-flex justify-content-around align-items-center flex-wrap">
          <span className="fw-semibold">Copyrights © 2025 4Health Homeopathy</span>
          <span className="fw-semibold">
            Developed by Aalan Techsoft - Salem
          </span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
